export default {
	zh: {
          helpTitle: "帮助",
          helpIntro1: "这是 ninja，我们的 CityJSON 可视化工具。",
          helpIntro2: '源代码可在 <a href="https://github.com/cityjson/ninja">GitHub</a> 找到，欢迎提出问题：<a href="https://github.com/cityjson/ninja/issues">这里</a>。',
          helpWhatToDo: "你可以执行以下操作：",
          helpStep1: "在左侧树形视图中点击对象 ID 以选择。",
          helpStep2: "在 3D 视图中点击对象以选择。",
          helpStep3: "选中对象后将显示信息卡片，点击带语义的表面也可查看信息。",
          helpStep4: "点击左下角按钮切换不同的 LoD。",
          helpStep5: "点击铅笔图标进入编辑模式并保存更改。",
          helpStep6: "点击“下载”按钮导出修改后的模型。",
          settings: "设置",
          cameraLight: "相机光源",
          doubleSide: "双面渲染",
          performanceMode: "性能模式",
          background: "背景",
          selection: "选中",
          loading: "加载中...",
          fileUploadTitle: "模型上传",
          fileUploadDesc: "上传 CityJSON (.json) 或 CityJSONSeq (.jsonl) 文件开始体验！",
          upload: "上传",
          chooseFile: "选择文件或拖拽到此处",
          performanceModalTitle: '性能模式',
          performanceModalBody: '你即将关闭性能模式。<br>这可能会在填充对象列表时导致浏览器短暂无响应。<br>根据模型大小，这可能需要几秒钟。<br>你确定要关闭性能模式吗？',
          performanceModalConfirm: '继续，我已准备好！',
          backgroundColor: '背景颜色',
          selectionColor: '选择颜色',
          objectColors: '对象颜色',
          surfaceColors: '表面颜色',
          conditionalFormatting: '条件格式',
          show: '显示',
          attribute: '属性',
          appearance: '外观',
          materialTheme: '材质主题',
          textureTheme: '纹理主题',
          textures: '纹理',
          download_btn: '下载',
          close_btn: '关闭',
          current_lab: '当前',
          obj_text: '三维对象',
          search_lab: '搜索 ID、对象类型或属性...',
          version_nav: '版本切换',
          pmode_title: "性能模式!",
          pmode_description: "系统检测到您拥有大量对象，<br>因此您当前处于性能模式。<br>在此模式下，对象列表将被禁用，<br>某些功能可能无法正常工作。<br>您仍然可以使用 3D 视图并选择对象。",
          pmode_warning: "您可以点击下方按钮选择禁用性能模式，但风险自负！",
          disable_pmode: "禁用性能模式",
          count_label: "个对象",
          version_lab: "模型版本: ",
          object_nav: "对象",
          version_sidebar: "版本",
          op_1: '选择表面',
          op_2: '显示语义',
          op_3: '环境光遮蔽',
          demo_1: '加载示例模型',
          demo_2: '加载示例场景',
          showtex: '纹理',
          fullscreen: '全屏',
          exitFullscreen: '退出全屏',
          cameraView: '视角',
          viewFront: '前视图',
          viewBack: '后视图',
          viewLeft: '左视图',
          viewRight: '右视图',
          viewTop: '俯视图',
          viewBottom: '仰视图',
          resetCamera: '恢复透视',
          performanceModeOn: '性能模式',
          performanceModeOff: '性能模式',
          enablePerformanceMode: '开启性能模式',
          disablePerformanceMode: '关闭性能模式',
          rotate: '旋转',
          rotating: '旋转中',
          startRotation: '开始旋转',
          stopRotation: '停止旋转',
          enable_tree_in_pmode: '启用对象树',
          pmode_tree_warning: '性能模式下运行，如遇卡顿可',
          hide_tree: '隐藏对象树',
        },
        en: {
          helpTitle: "Help",
          helpIntro1: "This is ninja, our viewer for CityJSON.",
          helpIntro2: 'The source code is available in <a href="https://github.com/cityjson/ninja">GitHub</a>. Please report any issues <a href="https://github.com/cityjson/ninja/issues">here</a>.',
          helpWhatToDo: "Here is what you can do:",
          helpStep1: "Click on an object ID in the tree view on the left to select it.",
          helpStep2: "Click or tap on an object in the 3D view to select it.",
          helpStep3: "When an object is selected you see a card with its information. If you click on a surface with semantics, its information will also be accessible.",
          helpStep4: "Toggle between different LoDs by clicking the buttons at the bottom left corner.",
          helpStep5: "Toggle editing mode with the pen icon, then save changes.",
          helpStep6: "Download the modified city model by clicking Download.",
          settings: "Settings",
          cameraLight: "Camera light",
          doubleSide: "Double side",
          performanceMode: "Performance mode",
          background: "Background",
          selection: "Selection",
          loading: "Loading...",
          fileUploadTitle: "File upload",
          fileUploadDesc: "Upload a CityJSON (.json) or CityJSONSeq (.jsonl) file to start!",
          upload: "Upload",
          chooseFile: "Choose file or drop it here...",
          performanceModalTitle: 'Performance mode',
          performanceModalBody: 'You are about to disable performance mode. This might temporarily make your browser unresponsive while the object list is populated. Depending on your model\'s size, this might take a few seconds. Are you sure you want to disable performance mode?',
          performanceModalConfirm: 'Go ahead, I am prepared!',
          disable_pmode: "Disable performance mode",
          backgroundColor: 'Background',
          selectionColor: 'Selection',
          objectColors: 'Object Colours',
          surfaceColors: 'Surface Colours',
          conditionalFormatting: 'Conditional formatting',
          show: 'Show',
          attribute: 'Attribute',
          appearance: 'Appearance',
          materialTheme: 'Material theme',
          textureTheme: 'Texture theme',
          textures: 'Textures',
          download_btn: 'Download',
          close_btn: 'Close',
          current_lab: 'Current',
          obj_text: 'City Objects',
          search_lab: 'Search for IDs, object type or attributes...',
          version_nav: 'Versions',
          pmode_title: "Performance mode!",
          pmode_description: "ninja detected that you have a large number of objects,<br>therefore you are currently in performance mode. In this<br>mode, the object list is disabled and certain features may<br>not work properly. You can still use the 3D view and select<br>objects.",
          pmode_warning: "You can choose to disable performance mode at your own risk by<br>clicking on the button below!",
          count_label: " total",
          version_lab: "Versions: ",
          object_nav: "Objects",
          version_sidebar: "Versions",
          op_1: 'Select surface',
          op_2: 'Semantics',
          op_3: 'Ambient Occlusion',
          demo_1: 'Load demo model',
          demo_2: 'Load demo scene',
          showtex: 'Textures',
          fullscreen: 'Fullscreen',
          exitFullscreen: 'Exit Fullscreen',
          cameraView: 'Camera View',
          viewFront: 'Front',
          viewBack: 'Back',
          viewLeft: 'Left',
          viewRight: 'Right',
          viewTop: 'Top',
          viewBottom: 'Bottom',
          resetCamera: 'Reset Perspective',
          performanceModeOn: 'Performance Mode',
          performanceModeOff: 'Performance Mode',
          enablePerformanceMode: 'Enable performance mode',
          disablePerformanceMode: 'Disable performance mode',
          rotate: 'Rotate',
          rotating: 'Rotating',
          startRotation: 'Start rotation',
          stopRotation: 'Stop rotation',
          enable_tree_in_pmode: 'Enable Object Tree',
          pmode_tree_warning: 'Running in performance mode. If lag occurs, ',
          hide_tree: 'hide object tree',
        },
}